(function () {
  'use strict';

  var config = window.CCAutocompleteConfig || {};
  var token = typeof config.mapboxToken === 'string' ? config.mapboxToken.trim() : '';

  if (!token) {
    return;
  }

  var country = config.country || 'CA';
  var language = config.language || 'fr';
  var minChars = Number(config.minChars || 3);
  var baseDebounceMs = Number(config.debounceMs || 400);
  var resultLimit = Number(config.limit || 6);
  var restrictToQuebec = config.restrictToQuebec !== false;
  var mapboxLogEndpoint = typeof config.mapboxLogEndpoint === 'string' ? config.mapboxLogEndpoint.trim() : '';
  var mapboxLogAction = typeof config.mapboxLogAction === 'string' ? config.mapboxLogAction.trim() : 'hello_child_log_mapbox_frontend_request';

  function getSafeNumber(value, fallback, min) {
    var parsed = Number(value);
    if (!isFinite(parsed) || parsed < min) {
      return fallback;
    }
    return parsed;
  }

  function logMapboxFrontendRequest(payload) {
    if (!mapboxLogEndpoint || typeof URLSearchParams !== 'function') {
      return;
    }

    var params = new URLSearchParams();
    params.set('action', mapboxLogAction);
    params.set('context', payload && payload.context ? String(payload.context) : 'city_autocomplete');
    params.set('method', payload && payload.method ? String(payload.method) : 'GET');
    params.set('url', payload && payload.url ? String(payload.url) : '');
    params.set('status', payload && typeof payload.status !== 'undefined' ? String(payload.status) : '0');

    if (payload && payload.error) {
      params.set('error', String(payload.error));
    }

    if (payload && typeof payload.durationMs !== 'undefined') {
      params.set('duration_ms', String(payload.durationMs));
    }

    if (typeof navigator !== 'undefined' && navigator && typeof navigator.sendBeacon === 'function' && typeof Blob === 'function') {
      try {
        var blob = new Blob([params.toString()], { type: 'application/x-www-form-urlencoded; charset=UTF-8' });
        var queued = navigator.sendBeacon(mapboxLogEndpoint, blob);
        if (queued) {
          return;
        }
      } catch (e) {
        // Fallback to fetch below.
      }
    }

    if (typeof fetch !== 'function') {
      return;
    }

    fetch(mapboxLogEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: params.toString(),
      credentials: 'same-origin',
      keepalive: true
    }).catch(function () {
      // Ignore logging transport failures.
    });
  }

  function debounce(fn, wait) {
    var timeout = null;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function getRegionCode(feature) {
    if (!feature || typeof feature !== 'object') {
      return '';
    }

    if (feature.properties && feature.properties.short_code) {
      return String(feature.properties.short_code).toUpperCase();
    }

    var context = Array.isArray(feature.context) ? feature.context : [];
    for (var i = 0; i < context.length; i += 1) {
      var item = context[i];
      if (item && item.id && String(item.id).indexOf('region.') === 0 && item.short_code) {
        return String(item.short_code).toUpperCase();
      }
    }

    return '';
  }

  function normalizeAllowedTypes(types) {
    return String(types || '')
      .split(',')
      .map(function (value) { return value.trim(); })
      .filter(Boolean);
  }

  function normalizeQuery(query) {
    return String(query || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();
  }

  function featureMatchesTypes(feature, allowedTypes) {
    if (!Array.isArray(feature.place_type) || !feature.place_type.length) {
      return false;
    }

    if (!Array.isArray(allowedTypes) || !allowedTypes.length) {
      return true;
    }

    return feature.place_type.some(function (placeType) {
      return allowedTypes.indexOf(String(placeType)) !== -1;
    });
  }

  function isAllowedFeature(feature, allowedTypes) {
    if (!feature || !Array.isArray(feature.place_type)) {
      return false;
    }

    if (!featureMatchesTypes(feature, allowedTypes)) {
      return false;
    }

    var context = Array.isArray(feature.context) ? feature.context : [];
    var countryCode = '';
    for (var i = 0; i < context.length; i += 1) {
      var item = context[i];
      if (item && item.id && String(item.id).indexOf('country.') === 0 && item.short_code) {
        countryCode = String(item.short_code).toUpperCase();
        break;
      }
    }

    if (countryCode && countryCode !== 'CA') {
      return false;
    }

    if (!restrictToQuebec) {
      return true;
    }

    var regionCode = getRegionCode(feature);
    return regionCode === 'CA-QC';
  }

  function fetchCities(query, types, allowedTypes, verifiedAddress) {
    if (verifiedAddress) {
      var addressParams = new URLSearchParams({ action: 'cc_pmpro_address_suggestions', query: query, nonce: config.addressNonce || '' });
      return fetch(config.addressEndpoint + '?' + addressParams.toString(), { credentials: 'same-origin' })
        .then(function (response) { return response.json(); })
        .then(function (payload) {
          if (!payload.success) throw new Error(payload.data && payload.data.message ? payload.data.message : 'La recherche d’adresse est indisponible.');
          return payload.data.features.filter(function (feature) { return !!feature.cc_address; });
        });
    }
    var endpoint = 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + encodeURIComponent(query) + '.json';

    var params = new URLSearchParams({
      access_token: token,
      autocomplete: 'true',
      country: country,
      language: language,
      limit: String(resultLimit),
      types: types || 'place'
    });

    var requestUrl = endpoint + '?' + params.toString();
    var startedAt = Date.now();

    return fetch(requestUrl, {
      method: 'GET'
    })
      .then(function (response) {
        if (!response.ok) {
          logMapboxFrontendRequest({
            context: 'city_autocomplete',
            method: 'GET',
            url: requestUrl,
            status: response.status,
            error: 'Mapbox HTTP ' + response.status,
            durationMs: Date.now() - startedAt
          });
          throw new Error('Mapbox HTTP ' + response.status);
        }

        logMapboxFrontendRequest({
          context: 'city_autocomplete',
          method: 'GET',
          url: requestUrl,
          status: response.status,
          durationMs: Date.now() - startedAt
        });

        return response.json();
      })
      .then(function (payload) {
        var features = payload && Array.isArray(payload.features) ? payload.features : [];
        return features.filter(function (feature) {
          return isAllowedFeature(feature, allowedTypes);
        });
      })
      .catch(function (error) {
        var message = error && error.message ? String(error.message) : 'Mapbox request failed';
        if (message.indexOf('Mapbox HTTP ') !== 0) {
          logMapboxFrontendRequest({
            context: 'city_autocomplete',
            method: 'GET',
            url: requestUrl,
            status: 0,
            error: message,
            durationMs: Date.now() - startedAt
          });
        }
        throw error;
      });
  }

  function getCityName(feature) {
    if (!feature || typeof feature !== 'object') {
      return '';
    }

    if (Array.isArray(feature.context)) {
      for (var i = 0; i < feature.context.length; i += 1) {
        var ctx = feature.context[i];
        if (ctx && ctx.id && String(ctx.id).indexOf('place.') === 0 && ctx.text) {
          return String(ctx.text);
        }
      }
    }

    if (Array.isArray(feature.place_type) && feature.place_type.indexOf('place') !== -1 && feature.text) {
      return String(feature.text);
    }

    return '';
  }

  function getContextTextByPrefix(feature, prefix) {
    if (!feature || !Array.isArray(feature.context)) {
      return '';
    }

    for (var i = 0; i < feature.context.length; i += 1) {
      var ctx = feature.context[i];
      if (ctx && ctx.id && String(ctx.id).indexOf(prefix) === 0 && ctx.text) {
        return String(ctx.text);
      }
    }

    return '';
  }

  function getProvinceName(feature) {
    var region = getContextTextByPrefix(feature, 'region.');
    if (region) {
      return region;
    }

    if (Array.isArray(feature.place_type) && feature.place_type.indexOf('region') !== -1 && feature.text) {
      return String(feature.text);
    }

    return '';
  }

  function getCountryName(feature) {
    var countryName = getContextTextByPrefix(feature, 'country.');
    if (countryName) {
      return countryName;
    }

    if (Array.isArray(feature.place_type) && feature.place_type.indexOf('country') !== -1 && feature.text) {
      return String(feature.text);
    }

    return '';
  }

  function getPostalCode(feature) {
    var postcode = getContextTextByPrefix(feature, 'postcode.');
    if (postcode) {
      return postcode;
    }

    if (Array.isArray(feature.place_type) && feature.place_type.indexOf('postcode') !== -1 && feature.text) {
      return String(feature.text);
    }

    return '';
  }

  function getAddressLine(feature) {
    if (!feature || typeof feature !== 'object') {
      return '';
    }

    var addressNumber = '';
    if (typeof feature.address === 'string' || typeof feature.address === 'number') {
      addressNumber = String(feature.address).trim();
    } else if (feature.properties && (typeof feature.properties.address === 'string' || typeof feature.properties.address === 'number')) {
      addressNumber = String(feature.properties.address).trim();
    }

    var streetText = typeof feature.text === 'string' ? feature.text.trim() : '';
    if (Array.isArray(feature.place_type) && feature.place_type.indexOf('address') !== -1) {
      var line = (addressNumber + ' ' + streetText).trim();
      if (line) {
        return line.replace(/\s+/g, ' ');
      }
    }

    if (typeof feature.place_name === 'string' && feature.place_name.trim() !== '') {
      return String(feature.place_name).split(',')[0].trim();
    }

    return streetText;
  }

  function safeDispatch(input, options) {
    var opts = options && typeof options === 'object' ? options : {};
    var shouldDispatchInput = opts.dispatchInput !== false;
    var shouldDispatchChange = opts.dispatchChange !== false;

    if (shouldDispatchInput) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    if (shouldDispatchChange) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function findTargetElement(selector, sourceInput, scope) {
    if (!selector) {
      return null;
    }

    var root = scope && typeof scope.querySelector === 'function' ? scope : null;
    var target = root ? root.querySelector(selector) : null;
    if (!target) {
      target = document.querySelector(selector);
    }

    if (!target || target === sourceInput) {
      return null;
    }

    return target;
  }

  function setTargetValue(selector, value, sourceInput, scope) {
    if (!selector) {
      return;
    }

    var target = findTargetElement(selector, sourceInput, scope);
    if (!target) {
      return;
    }

    target.value = value;

    var suppressAutocompleteInput = target.matches('[data-city-autocomplete], .cc-mapbox-address-input, .cc-mapbox-city-input');
    safeDispatch(target, suppressAutocompleteInput ? { dispatchInput: false, dispatchChange: true } : null);
  }

  function initAutocomplete(input) {
    if (!input || ['hidden', 'checkbox', 'radio'].indexOf(input.type) !== -1 || input.dataset.cityAutocompleteReady === '1') {
      return;
    }

    input.dataset.cityAutocompleteReady = '1';

    // Dans PMPro, seule l'adresse lance une recherche; ses composantes sont alimentées ensemble.
    if (input.name !== 'user_adresse' && input.form && input.form.querySelector('[data-cc-address-search="1"]') &&
        ['user_city', 'user_province', 'user_postal_code', 'user_country'].indexOf(input.name) !== -1) {
      input.readOnly = true;
      return;
    }

    var wrapper = input.closest('.cc-city-autocomplete') ||
      input.closest('.cc-mapbox-address') ||
      input.closest('.cc-mapbox-city') ||
      input.parentElement;
    if (!wrapper) {
      return;
    }

    if (window.getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    var panel = document.createElement('div');
    panel.className = 'cc-city-suggestions';
    panel.hidden = true;
    wrapper.appendChild(panel);

    var formScope = input.form || input.closest('form') || document;
    var hasAddressClass = input.classList.contains('cc-mapbox-address-input') || !!input.closest('.cc-mapbox-address');
    var mode = String(input.dataset.mapboxMode || '').trim().toLowerCase();
    var isAddressField = hasAddressClass;
    var verifiedAddress = input.dataset.ccAddressSearch === '1';

    if (mode === 'address') {
      isAddressField = true;
    }

    if (mode === 'city') {
      isAddressField = false;
    }

    var types = input.dataset.mapboxTypes || (isAddressField ? 'address,place,postcode' : 'place');
    var allowedTypes = normalizeAllowedTypes(types);
    var valueMode = input.dataset.valueMode || (isAddressField ? 'place_name' : 'city');
    var effectiveMinChars = isAddressField
      ? getSafeNumber(config.addressMinChars, Math.max(4, minChars), 1)
      : getSafeNumber(config.cityMinChars, minChars, 1);
    var effectiveDebounceMs = isAddressField
      ? getSafeNumber(config.addressDebounceMs, Math.max(500, baseDebounceMs), 0)
      : getSafeNumber(config.cityDebounceMs, baseDebounceMs, 0);

    var latTarget = input.dataset.latTarget || '.cc-mapbox-lat-input, .cc-mapbox-lat input, .cc-mapbox-lat textarea, #company_latitude';
    var lngTarget = input.dataset.lngTarget || '.cc-mapbox-lng-input, .cc-mapbox-lng input, .cc-mapbox-lng textarea, #company_longitude';
    var cityTarget = input.dataset.cityTarget || '.cc-mapbox-city-input, .cc-mapbox-city input, .cc-mapbox-city textarea';
    var addressTarget = input.dataset.addressTarget || '.cc-mapbox-address-input, .cc-mapbox-address input, .cc-mapbox-address textarea';
    var provinceTarget = input.dataset.provinceTarget || '.cc-mapbox-province-input, .cc-mapbox-province input, .cc-mapbox-province textarea';
    var postalTarget = input.dataset.postalTarget || '.cc-mapbox-postal-input, .cc-mapbox-postal input, .cc-mapbox-postal textarea';
    var countryTarget = input.dataset.countryTarget || '.cc-mapbox-country-input, .cc-mapbox-country input, .cc-mapbox-country textarea';
    var selectedValueForSuppression = '';
    var searchSequence = 0;
    var lastSubmittedQuery = '';
    var addressKeys = ['user_adresse', 'user_city', 'user_province', 'user_postal_code', 'user_country', 'company_latitude', 'company_longitude'];

    function verifiedAddressTarget(name) {
      var target = formScope.elements[name];
      if (!target && ['company_latitude', 'company_longitude', 'cc_address_selection'].indexOf(name) !== -1) {
        target = document.createElement('input');
        target.type = 'hidden';
        target.name = name;
        formScope.appendChild(target);
      }
      return target;
    }

    function clearAddressSelection() {
      verifiedAddressTarget('cc_address_selection').value = '';
      delete input.dataset.ccAddressValues;
      addressKeys.forEach(function (name) {
        var target = verifiedAddressTarget(name);
        if (target && target !== input) target.value = '';
      });
      selectedValueForSuppression = '';
      lastSubmittedQuery = '';
      invalidatePendingSearches();
      clearPanel();
    }

    if (verifiedAddress) {
      if (verifiedAddressTarget('cc_address_selection').value && input.dataset.ccAddressValues) {
        var initialValues = JSON.parse(input.dataset.ccAddressValues);
        addressKeys.forEach(function (name) {
          var target = verifiedAddressTarget(name);
          if (target) target.value = initialValues[name];
        });
      }
      addressKeys.forEach(function (name) {
        var target = verifiedAddressTarget(name);
        if (target && target !== input) {
          target.readOnly = true;
          target.setAttribute('aria-readonly', 'true');
        }
      });
    }

    function invalidatePendingSearches() {
      searchSequence += 1;
    }

    function clearPanel() {
      panel.innerHTML = '';
      panel.hidden = true;
    }

    function selectFeature(feature) {
      if (verifiedAddress) {
        if (!feature.cc_address) return;
        var selection = feature.cc_address;
        invalidatePendingSearches();
        addressKeys.forEach(function (name) {
          var target = verifiedAddressTarget(name);
          if (target) target.value = selection.values[name];
        });
        input.dataset.ccAddressValues = JSON.stringify(selection.values);
        verifiedAddressTarget('cc_address_selection').value = selection.token;
        selectedValueForSuppression = input.value;
        lastSubmittedQuery = normalizeQuery(input.value);
        clearPanel();
        addressKeys.forEach(function (name) {
          var target = verifiedAddressTarget(name);
          if (target) safeDispatch(target, { dispatchInput: false });
        });
        return;
      }
      var cityValue = getCityName(feature);
      if (!cityValue && valueMode === 'city' && feature && feature.text) {
        cityValue = String(feature.text);
      }
      var placeName = feature && feature.place_name ? String(feature.place_name) : cityValue;
      var addressLine = getAddressLine(feature) || placeName;
      var provinceValue = getProvinceName(feature);
      var postalValue = getPostalCode(feature);
      var countryValue = getCountryName(feature);
      var center = feature && Array.isArray(feature.center) ? feature.center : [];
      var lng = center.length >= 2 ? Number(center[0]) : null;
      var lat = center.length >= 2 ? Number(center[1]) : null;
      var selectedInputValue = valueMode === 'place_name' ? placeName : cityValue;

      if (isAddressField) {
        selectedInputValue = addressLine || placeName || cityValue;
      }

      invalidatePendingSearches();
      selectedValueForSuppression = selectedInputValue;
      lastSubmittedQuery = normalizeQuery(selectedValueForSuppression);
      input.value = selectedInputValue;
      safeDispatch(input);

      if (cityValue) {
        setTargetValue(cityTarget, cityValue, input, formScope);
      }

      if (valueMode !== 'city' && addressLine) {
        setTargetValue(addressTarget, addressLine, input, formScope);
      }

      if (provinceValue) {
        setTargetValue(provinceTarget, provinceValue, input, formScope);
      }

      if (postalValue) {
        setTargetValue(postalTarget, postalValue, input, formScope);
      }

      if (countryValue) {
        setTargetValue(countryTarget, countryValue, input, formScope);
      }

      if (lat !== null && !Number.isNaN(lat) && lng !== null && !Number.isNaN(lng)) {
        setTargetValue(latTarget, String(lat), input, formScope);
        setTargetValue(lngTarget, String(lng), input, formScope);
      }

      clearPanel();
    }

    function render(features) {
      panel.innerHTML = '';

      if (!features.length) {
        panel.hidden = !verifiedAddress;
        if (verifiedAddress) panel.textContent = 'Aucune adresse complète trouvée. Précisez le numéro et la rue.';
        return;
      }

      var frag = document.createDocumentFragment();

      features.forEach(function (feature) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cc-city-suggestion';
        btn.textContent = feature.place_name || feature.text || '';
        btn.addEventListener('mousedown', function (event) {
          event.preventDefault();
        });
        btn.addEventListener('click', function () {
          selectFeature(feature);
        });
        frag.appendChild(btn);
      });

      panel.appendChild(frag);
      panel.hidden = false;
    }

    var runSearch = debounce(function () {
      if (verifiedAddress && input.readOnly) return;
      var query = String(input.value || '').trim();
      var normalizedQuery = normalizeQuery(query);

      if (selectedValueForSuppression !== '' && query === selectedValueForSuppression) {
        return;
      }
      selectedValueForSuppression = '';

      if (query.length < effectiveMinChars) {
        lastSubmittedQuery = '';
        invalidatePendingSearches();
        clearPanel();
        return;
      }

      if (normalizedQuery !== '' && normalizedQuery === lastSubmittedQuery) {
        return;
      }

      lastSubmittedQuery = normalizedQuery;
      var requestSequence = ++searchSequence;
      fetchCities(query, types, allowedTypes, verifiedAddress)
        .then(function (features) {
          if (requestSequence !== searchSequence) {
            return;
          }
          render(features);
        })
        .catch(function (error) {
          if (requestSequence !== searchSequence) {
            return;
          }
          lastSubmittedQuery = '';
          clearPanel();
          if (verifiedAddress) {
            panel.textContent = 'La recherche d’adresse est indisponible. Réessayez.';
            panel.hidden = false;
          }
        });
    }, effectiveDebounceMs);

    input.addEventListener('input', function () {
      if (verifiedAddress && input.dataset.ccAddressValues) {
        var selectedAddress = JSON.parse(input.dataset.ccAddressValues).user_adresse;
        if (input.value === selectedAddress) return;
        clearAddressSelection();
      }
      if (verifiedAddress) {
        invalidatePendingSearches();
        lastSubmittedQuery = '';
        clearPanel();
      }
      runSearch();
    });

    document.addEventListener('click', function (event) {
      if (!wrapper.contains(event.target)) {
        invalidatePendingSearches();
        clearPanel();
      }
    });
  }

  function initAll() {
    var selector = [
      '[data-city-autocomplete]',
      '.cc-mapbox-address-input',
      '.cc-mapbox-address input',
      '.cc-mapbox-address textarea',
      '.cc-mapbox-city-input',
      '.cc-mapbox-city input',
      '.cc-mapbox-city textarea',
    ].join(',');

    var inputs = document.querySelectorAll(selector);
    if (!inputs.length) {
      return;
    }

    inputs.forEach(initAutocomplete);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();

    var observer = new MutationObserver(function () {
      initAll();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
